enum QuestionClassification {
    Custom = 'Custom',
    Foundation = 'Foundation',
    General = 'General',
    Quiz = 'Quiz',
}

export default QuestionClassification;
